"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.faq =
  twentyninetimes.faq ||
  (function () {
    var faqItems = document.querySelectorAll(".js-item-faq");

    function init() {
      if (faqItems.length > 0) {
        for (let i = 0; i < faqItems.length; i++) {
          const item = faqItems[i];

          item.addEventListener("click", function (e) {
            const clickedItem = e.currentTarget;
            const text = clickedItem.querySelector(".js-item-faq-text");
            const textScrollHeight = text.scrollHeight;

            if (clickedItem.classList.contains("item-faq--open")) {
              text.style.maxHeight = "0";
            } else {
              text.style.maxHeight = textScrollHeight + "px";
            }
            clickedItem.classList.toggle("item-faq--open");
          });
        }
      }
    }

    return {
      init,
    };
  })();
